import { QueryFactory } from "../../../../Common";
export const QGetMarketsByEventId = QueryFactory("GetMarketsByEventId");
//# sourceMappingURL=QGetMarketsByEventId.js.map